<template>
  <div class="activity-stream">
    <div
      v-if="!hasActivities"
      class="activity-stream__empty"
    >
      No recent activities.
    </div>
    <div v-else class="activity-stream__line" />
    <ol class="activity-stream__list">
      <li v-if="slotPassed" class="activity-stream__list-item">
        <slot />
      </li>
      <li
        v-for="activity in activityStream.activities"
        :key="activity.id"
        class="activity-stream__list-item"
      >
        <single-activity
          :activity="activity"
          :show-user-avatar="showUserAvatar"
          :show-username="showUsername"
          :show-activity-type="showActivityType"
        />
      </li>
    </ol>
    <div v-if="hasScrollPagination">
      <loading-spinner v-if="hasNextPage" />
      <div ref="sentinel" class="activity-stream__sentinel" />
    </div>
  </div>
</template>

<script>
import SingleActivity from '@/components/User/Activity/SingleActivity.vue';

export default {
  name: 'ActivityStream',
  components: {
    SingleActivity,
  },
  props: {
    activityStream: {
      type: Object,
      required: true,
    },
    showUserAvatar: {
      type: Boolean,
      default: false,
    },
    showUsername: {
      type: Boolean,
      default: false,
    },
    showActivityType: {
      type: Boolean,
      default: false,
    },
    hasScrollPagination: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      observer: undefined,
    };
  },
  computed: {
    hasActivities() {
      return this.activityStream.activities.length;
    },
    hasNextPage() {
      return this.activityStream.pageInfo.hasNextPage;
    },
    slotPassed() {
      return !!this.$slots.default;
    },
  },
  mounted() {
    if (this.hasScrollPagination) {
      this.observeActivityStream();
      this.$nextTick(() => {
        this.observeActivityStream();
      });
    }
  },
  methods: {
    observeActivityStream() {
      this.observer = new IntersectionObserver((sentinel) => {
        if (!sentinel[0].isIntersecting) {
          return;
        }
        this.observer.unobserve(sentinel[0].target);
        this.handleScroll();
      });
      this.observer.observe(this.$refs.sentinel);
    },
    handleScroll() {
      if (!this.hasNextPage) {
        return;
      }
      this.$emit('loadMore', this.activityStream.pageInfo.endId);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_activity-stream';
</style>

<docs>
A stream of activities. It is used in the Community Hub, Activity Summary and
Activity Page

Includes an optional slot to inject a component as the first item in the Activity stream
</docs>
